// controllers/local-storage-behavior-controller.ts
import { BehaviorSubject } from "rxjs";
import { RXController } from "./RXController.js";
import "./chemistry-controller.js";
var localStorageSubjectMap = /* @__PURE__ */ new Map();
function getOrCreate(key, defaultValue) {
  if (!localStorageSubjectMap.get(key))
    localStorageSubjectMap.set(key, new BehaviorSubject(defaultValue));
  return localStorageSubjectMap.get(key);
}
function getValue(lsKey) {
  return localStorage.getItem(lsKey) ? JSON.parse(localStorage.getItem(lsKey)) : void 0;
}
var LocalStorageBehaviorController = class extends RXController {
  constructor(host, localStorageKey, defaultValue, rxControllerOptions = {}) {
    super(
      host,
      getOrCreate(localStorageKey, getValue(localStorageKey) ?? defaultValue),
      void 0,
      rxControllerOptions
    );
    this.lsKey = "";
    this.lsKey = localStorageKey;
    this.defaultValue = defaultValue;
  }
  next(value) {
    value = value !== null && value !== void 0 ? value : this.defaultValue;
    const nextValue = JSON.stringify(value);
    if (nextValue === localStorage.getItem(this.lsKey))
      return;
    localStorage.setItem(this.lsKey, nextValue);
    return super.next(value);
  }
  delete() {
    localStorage.removeItem(this.lsKey);
  }
};
export {
  LocalStorageBehaviorController
};
